import { render, staticRenderFns } from "./InscriptionDetails.vue?vue&type=template&id=4466d839&"
import script from "./InscriptionDetails.vue?vue&type=script&lang=js&"
export * from "./InscriptionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports